import { useTranslation } from '../../i18n/LanguageContext'
import './HeroLogo.css'

const HeroLogo = () => {
  const { t } = useTranslation()
  return (
    <div className="hero__logo">
      <img 
        src="/assets/logo-128x128.svg" 
        alt={t('hero.logoAlt')} 
        className="hero__logo-img"
      />
      <h2 className="hero__logo-title">Unity-BOT</h2>
    </div>
  )
}

export default HeroLogo
